import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../constants/queryKeys';
import { ApiEndpoints } from '../../../constants/endpoints/apiEndpoints.ts';
import { baseQueryKeys } from '@cks-internal/react-base';
import { ActivityEndpoints } from '../../../constants/endpoints/activityEndpoints.ts';
import { CommunicationRecordTargetType } from '../../../globalModels/common/communicationRecordTargetType.ts';

export const useActivityQueryInvalidator = (activityId: number) => {
  const queryClient = useQueryClient();

  const invalidEmailQueriesForActivity = async () => {
    await queryClient.invalidateQueries({
      queryKey: [ActivityEndpoints.communicationRecords.get(activityId)],
      type: 'all'
    });

    await queryClient.invalidateQueries({
      queryKey: [
        ...baseQueryKeys.querySelectOptions(
          ApiEndpoints.compose.get.attachments(CommunicationRecordTargetType.Activity, activityId)
        )
      ],
      type: 'all'
    });
  };
  const invalidateAllQueriesForActivity = async () => {
    await queryClient.refetchQueries({
      queryKey: [QueryKeys.editActivity(activityId)],
      type: 'all'
    });
    await queryClient.refetchQueries({
      queryKey: [ActivityEndpoints.communicationRecords.get(activityId)],
      type: 'all'
    });

    await queryClient.refetchQueries({
      queryKey: [
        ...baseQueryKeys.querySelectOptions(
          ApiEndpoints.compose.get.attachments(CommunicationRecordTargetType.Activity, activityId)
        )
      ],
      type: 'all'
    });

    await queryClient.invalidateQueries({
      queryKey: ['reconciliationEditorViewModel', activityId],
      type: 'all'
    });
  };

  const invalidateStatusQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [QueryKeys.editActivity(activityId), ActivityEndpoints.activityStatus(activityId)],
      type: 'all'
    });
  };

  const invalidateEndpointOnly = async (endpoint: string) => {
    await queryClient.invalidateQueries({
      queryKey: [QueryKeys.editActivity(activityId), endpoint],
      type: 'all'
    });
  };

  return {
    invalidateAllQueriesForActivity,
    invalidateEndpointOnly,
    invalidateStatusQuery,
    invalidEmailQueriesForActivity,
    queryClient
  };
};
